<section class="spacing--padding-all" data-test="employee-relation-create">
  <button
    mat-button
    type="button"
    class="employee-relation-create__back"
    (click)="backToRelations()"
    data-test="employee-relation-create__back"
  >
    <mat-icon>arrow_back</mat-icon>
    {{ 'app.employee.relations.back_to_relations' | translate }}
  </button>

  <div class="form-field-wrapper">
    <div class="text--h6">
      {{ 'app.employee.relations.title_search_customer' | translate }}
    </div>
    <div class="search-customer__container">
      <app-search-field
        class="search-customer"
        [value]="selectedCustomer()?.name"
        [placeholderText]="'app.customer.search.placeholder' | translate"
        [autoCompleteOptions]="customers$"
        [isLoading$]="isLoading$"
        (optionSelected)="selectCustomer($event)"
        (searchValueChanged)="searchValueChanged($event)"
      ></app-search-field>
    </div>

    @if (selectedCustomer() && locations() !== undefined) {
      <div class="text--h6">
        {{ 'app.employee.relations.title_select_location' | translate }}
      </div>

      <ng-container [agrBlockSpinner]="saving()">
        @if (locations()?.length === 0) {
          <div class="wrapper--spacing-horizontal">
            <agr-notification-empty
              emptyTitle="{{ 'app.no_results_title' | translate }}"
              emptyDescription="{{ 'app.no_results_description' | translate }}"
            ></agr-notification-empty>
          </div>
        } @else {
          <mat-slide-toggle
            labelPosition="after"
            color="primary"
            [checked]="hasCustomerRelation()"
            (change)="toggleAllLocations($event)"
            data-test="employee-relations__toggleAll"
          >
            {{ 'app.employee.relations.all_locations_relation_label' | translate }}
          </mat-slide-toggle>
          <mat-nav-list>
            @for (location of locations(); track location.id) {
              <a
                href="#"
                mat-list-item
                class="listItem"
                data-test="employee-relations__location"
                (click)="clickRelationForLocation($event, location)"
              >
                <mat-icon matListItemAvatar class="list-avatar">perm_identity</mat-icon>
                <div matListItemTitle class="text--h3">
                  {{ location.name }}
                </div>
                <div matListItemLine class="text--gray">
                  {{ location.street }} {{ location.houseNumber }}
                  {{ location.houseNumberAddition }} {{ location.postalCode }} {{ location.city }},
                  {{ 'app.countries.' + location.country | translate }}
                </div>
                <mat-slide-toggle
                  matListItemMeta
                  labelPosition="after"
                  color="primary"
                  [checked]="location.hasRelation"
                  (click)="$event.preventDefault(); $event.stopPropagation()"
                  (change)="toggleRelationForLocation($event, location)"
                  [attr.data-test]="'employee-relations__location--' + location.id"
                >
                  {{ 'app.employee.relations.has_relation_label' | translate }}
                </mat-slide-toggle>
              </a>
            }
            <mat-divider></mat-divider>
          </mat-nav-list>
        }
      </ng-container>
    }
  </div>
</section>
